import React, { useCallback, useState, useEffect } from 'react'
import { useModal } from 'react-modal-hook'
import moment from 'moment'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory, useLocation } from 'react-router-dom'
import AccountDisplay from '../../../components/account-display/account-display'
import BeneficiaryDisplay from '../../../components/beneficiary-display/beneficiary-display'
import Modal from '../../../components/Modal/Modal'
import NeoButton from '../../../components/NeoButton/NeoButton'
import LayoutWithAccountCard from '../../../layout/Layout/layout-account-card'
import { InternationalTransferSchema } from '../../../schemas/beneficiary-transfer'
import { carouselCurrentItemSelector, getFeatureListSelector } from '../../../selectors'
import DashboardService from '../../../services/dashboard.service'
import { Formik, Form, Field } from 'formik'
import NeoInput from '../../../components/NeoInput/NeoInput'
import InputError from '../../../components/InputError/InputError'
import NeoSuccess from '../../../components/FormComponents/NeoSuccess'
import NeoOTP from '../../../components/FormComponents/NeoOTP'
import Loading from 'custom/assets/loaders/Loading'
import { useTranslation } from 'react-i18next'
import {
  BENEFICIARY_TRANSFER_KEYS,
  AUTH_KEYS,
  RECIPTS_KEYS,
  DIALOG_KEYS,
  DEPOSITS_KEYS,
  REQUESTS_KEYS,
  SIDENAV_KEYS,
  VALIDATION_MESSAGES,
} from '../../../utils/translation-constants'
import BeneficiaryTransferService from '../../../services/beneficiary-transfers.service'
import { setAccRefresh } from '../../../actions'
import TermsAndCondition from '../../../components/TermsAndConditions/TermsAndCondition'
import config from 'custom/config/environment'
import NumberFormat from 'react-number-format'

import validationConfig from 'custom/config/validation.config.json'
const internationalTransferConfig = validationConfig['transfers']['international']

export default function InternationalAccountTransfer() {
  const dispatch = useDispatch()
  const history = useHistory()
  const location = useLocation()
  const [message, setMessage] = useState('')
  const [loading, setLoading] = useState(false)
  const [stage, setStage] = useState(1)
  const [otp, setOtp] = useState('')
  const [otpEnabled, setOtpEnabled] = useState(false)
  const [beneDetails, setBeneDetails] = useState({})
  const [formValues, setFormValues] = useState({})
  const [verifyDetails, setVerifyDetails] = useState({})
  const [transferType, setTransferType] = useState({})
  const [currencyList, setCurrencyList] = useState([])
  const [remarksList, setRemarksList] = useState([])
  const [confirmMessage, setConfirmMessage] = useState()
  const currentAccountDetail = useSelector(carouselCurrentItemSelector)
  const [selectedModeOfTransfer, setSelectedModeOfTransfer] = useState('N')
  const { t } = useTranslation()
  const featureList = useSelector(getFeatureListSelector)
  const [successResponse, setSuccessResponse] = useState({})

  const [showModal, hideModal] = useModal(
    () => (
      <Modal>
        <div className='modal-error-body'>
          <h6>
            <b>{message?.code}</b> : {message?.message}
          </h6>
          <div className='modal-btn-style'>
            <NeoButton
              mode='newDesign'
              type='button'
              text={t(DIALOG_KEYS.CLOSE)}
              onClick={() => {
                hideModal()
                // history.push('/beneficiary-transfers/transfers')
              }}
            />
          </div>
        </div>
      </Modal>
    ),
    [message],
  )
  const [showConfirmModal, hideConfirmModal] = useModal(
    () => (
      <Modal>
        <div className='modal-error-body'>
          <h6>{confirmMessage}</h6>
          <div className='mt-4 d-flex justify-content-evenly'>
            <div className='col-6'>
              <NeoButton
                mode='newDesign'
                type='button'
                text={t(DIALOG_KEYS.CONFIRM_YES)}
                onClick={() => {
                  hideConfirmModal()
                  otpEnabled ? setStage(3) : onConfirm()
                }}
              />
            </div>
            <div className='col-6'>
              <NeoButton
                mode='newDesign'
                type='button'
                text={t(DIALOG_KEYS.CONFIRM_NO)}
                onClick={() => {
                  hideConfirmModal()
                  history.push('/beneficiary-transfers/transfers')
                }}
              />
            </div>
          </div>
        </div>
      </Modal>
    ),
    [confirmMessage, otpEnabled],
  )

  useEffect(() => {
    if (location.state === undefined) {
      history.push('/beneficiary-transfers')
      return
    }
    setBeneDetails(location?.state?.beneDetails)
    setTransferType(location?.state?.transferType)
    fetchCurrencyList()
    // fetchInternalCurrencyList()
    getRemarksList()
  }, [])

  const getRemarksList = useCallback(async () => {
    try {
      const response = await DashboardService.getRemarksCategory()
      if (response.status === 200) {
        setLoading(false)
        setRemarksList(response.data.remarks)
      }
    } catch (err) {}
  }, [])

  const fetchCurrencyList = useCallback(async () => {
    const response = await BeneficiaryTransferService.getCurrencyList()
    if (response.status === 200) {
      setCurrencyList(response.data)
    }
  })

  const onVerify = useCallback(
    async (values) => {
      try {
        if (featureList['BENE_SWIFT'][currentAccountDetail['accountType']] === 'N') {
          setMessage({
            code: t(DIALOG_KEYS.NO_ACCESS),
            message: t(DIALOG_KEYS.NO_ACCOUNTS),
          })
          showModal()
          return
        }
        setLoading(true)
        setFormValues(values)

        if (values.transferAmount === '0.00' || values.transferAmount === '.00') {
          return
        }
        const reqParams = {
          fin: {
            srcAccount: currentAccountDetail?.accountNo,
            srcAccBranch: currentAccountDetail?.brnCode,
            srcAccCcy: currentAccountDetail?.currency,
            destAccount: beneDetails?.beneAccNo,
            destAccBranch: '',
            destAccCcy: '',
            destBankName: '',
            bicCode: '',
            sortCode: '',
            txnCurrency: values.txnCurrency,
            amount: values.transferAmount,
            remarks: values.remarks === 'Custom' ? values.customRemarks : values.remarks,
            chargesBorneBy: values.chargesBorneBy,
          },
          nfin: {
            transferType: values.transferType,
            beneId: beneDetails?.beneId,
            scheduled: values.isScheduled === 'Yes' ? true : false,
            scheduledDate: values.scheduledDate,
            beneficiaryName: '',
            beneficiaryMail: '',
            beneficiaryMobile: '',
            addBeneficiary: false,
          },
          cdf: {
            FXREFNO: config.FX_DEAL_REF_NO && values.hasFxRefNo === 'Y' ? values.fxRefNo : '',
            senderToReceiverInfo: values.senderToReceiverInfo.toUpperCase(),
          },
          requestId: 'FTVERIFYSWIFT',
        }
        const response = await BeneficiaryTransferService.verifyFundTransfer(reqParams)
        if (response.status === 200) {
          setOtpEnabled(response.data['otpEnabled'])
          setConfirmMessage(response.data['message'])
          setVerifyDetails(response.data)
          setStage(2)
          setLoading(false)
        }
      } catch (err) {
        setLoading(false)
      }
    },
    [beneDetails, transferType, currentAccountDetail, featureList],
  )

  const onConfirm = useCallback(async () => {
    try {
      setLoading(true)
      const reqParams = {
        fin: {
          srcAccount: currentAccountDetail?.accountNo,
          srcAccBranch: currentAccountDetail?.brnCode,
          srcAccCcy: currentAccountDetail?.currency,
          destAccount: beneDetails?.beneAccNo,
          destAccBranch: '',
          destAccCcy: '',
          destBankName: '',
          bicCode: '',
          sortCode: '',
          txnCurrency: formValues.txnCurrency,
          amount: formValues.transferAmount,
          remarks: formValues.remarks === 'Custom' ? formValues.customRemarks : formValues.remarks,
          chargesBorneBy: formValues.chargesBorneBy,
        },
        nfin: {
          transferType: formValues.transferType,
          beneId: beneDetails?.beneId,
          scheduled: formValues.isScheduled === 'Yes' ? true : false,
          scheduledDate: formValues.scheduledDate,
          beneficiaryName: '',
          beneficiaryMail: '',
          beneficiaryMobile: '',
          addBeneficiary: false,
          otp: verifyDetails.otpEnabled ? otp : '0000',
        },
        cdf: {
          FXREFNO: config.FX_DEAL_REF_NO && formValues.hasFxRefNo === 'Y' ? formValues.fxRefNo : '',
          senderToReceiverInfo: formValues.senderToReceiverInfo.toUpperCase(),
        },
        requestId: 'FTCONFIRMSWIFT',
        module: 'FUNDTRANSFER',
      }
      const response = await BeneficiaryTransferService.confirmFundTransfer(reqParams)
      if (response.status === 200) {
        dispatch(setAccRefresh(true))
        setSuccessResponse(response.data)
        setMessage(response.data['message'])
        setStage(4)
        setLoading(false)
      }
    } catch (err) {
      setOtp('')
      setLoading(false)
    }
  }, [beneDetails, transferType, currentAccountDetail, otp, formValues])

  function renderSwitch() {
    switch (stage) {
      case 1:
        return renderForm()
      case 2:
        return renderConfirm()
      case 3:
        return <NeoOTP otp={otp} setOTP={setOtp} onSubmit={onConfirm} loading={loading} />
      case 4:
        return (
          <NeoSuccess
            onClick1={() =>
              BeneficiaryTransferService.downLoadReport({
                transRefNum: successResponse.referenceNo,
                refId: '',
                module: 'FUNDTRANSFER',
              })
            }
            module='DOWNLOAD_RECEIPT'
            message={message}
            linkPath='/beneficiary-transfers'
          />
        )
      default:
        return renderForm()
    }
  }

  function renderLoading() {
    return (
      <div className='mx-4 rounded d-flex justify-content-center align-items-center'>
        <Loading width='50px' height='50px' />
      </div>
    )
  }

  function renderForm() {
    return (
      <>
        <AccountDisplay currentAccountDetail={currentAccountDetail} />
        <p style={{ fontSize: 10, fontWeight: 600, paddingLeft: 30 }}>To</p>
        <BeneficiaryDisplay beneDetails={beneDetails} />
        <Formik
          initialValues={{
            transferAmount: '',
            remarks: '',
            txnCurrency: '',
            transferType: 'SWIFT',
            hasFxRefNo: config.FX_DEAL_REF_NO ? 'N' : '',
            senderToReceiverInfo: '',
            fxRefNo: '',
            customRemarks: '',
            isScheduled: 'No',
            scheduledDate: '',
            chargesBorneBy: '',
          }}
          enableReinitialize
          validationSchema={InternationalTransferSchema}
          onSubmit={onVerify}>
          {({ isSubmitting, errors, touched, setFieldValue, handleChange, values }) => (
            <Form>
              <div>
                <label style={{ display: 'block' }} className='control-label'>
                  {t(BENEFICIARY_TRANSFER_KEYS.TRANSFER_DETAILS_KEYS.TRANSFER_TYPE)}
                </label>
                <div className='custom-control custom-radio custom-control-inline pt-20'>
                  <Field
                    tabIndex={'1'}
                    as='input'
                    type='radio'
                    id='transferTypeSelect1'
                    name='transferType'
                    value='SWIFT'
                    className='custom-control-input'
                  />
                  <label className='custom-control-label' htmlFor='transferTypeSelect1'>
                    {t(BENEFICIARY_TRANSFER_KEYS.TRANSFER_DETAILS_KEYS.SWIFT)}
                  </label>
                </div>
              </div>

              <div className='form-group'>
                <NeoInput
                  tabIndex='2'
                  showAsterisk={internationalTransferConfig['isAmountRequired']}
                  text={t(BENEFICIARY_TRANSFER_KEYS.TRANSFER_CONFIRM_KEYS.TRANSFER_AMOUNT)}
                  name='amount'
                  onChange={(values) => {
                    setFieldValue('transferAmount', values.value)
                  }}
                  mode='amount'
                />
                <InputError text={errors.transferAmount} touched={touched.transferAmount} />
                <InputError
                  text={t(VALIDATION_MESSAGES.AMOUNT_VALID)}
                  touched={values.transferAmount === '0.00' || values.transferAmount === '.00'}
                />
                {/* <InputError
                  text={'Insufficient Balance in Selected Account'}
                  touched={parseInt(currentAccountDetail?.odBal) <= parseInt(values.transferAmount)}
                /> */}
              </div>

              <div className='mt-3 form-group'>
                <NeoInput
                  tabIndex='3'
                  showAsterisk={internationalTransferConfig['isCurrencyRequired']}
                  text={t(DEPOSITS_KEYS.TERM_DEPOSITS_KEYS.CURRENCY)}
                  mode='select'
                  name='txnCurrency'
                  onChange={(e) => {
                    handleChange(e)
                  }}
                  list={currencyList}
                  keyValue={'currencyCode'}
                />
                <InputError text={errors.txnCurrency} touched={touched.txnCurrency} />
              </div>
              {config.FX_DEAL_REF_NO && (
                <div style={{ marginTop: 20 }}>
                  <div className='custom-control custom-radio custom-control-inline pt-20'>
                    <h5>{t(BENEFICIARY_TRANSFER_KEYS.BENEFICIARY_TRANSFER.HAS_FX_DEAL)}?</h5>
                  </div>

                  <div className='custom-control custom-radio custom-control-inline pt-20'>
                    <Field
                      tabIndex={'4'}
                      as='input'
                      type='radio'
                      id='transferTypeSelect3'
                      name='hasFxRefNo'
                      value='Y'
                      onChange={(text) => {
                        handleChange(text)
                        setSelectedModeOfTransfer(text.target.value)
                      }}
                      className='custom-control-input'
                    />
                    <label className='custom-control-label' htmlFor='transferTypeSelect3'>
                      {t(BENEFICIARY_TRANSFER_KEYS.BENEFICIARY_TRANSFER.YES)}
                    </label>
                  </div>

                  <div className='custom-control custom-radio custom-control-inline'>
                    <Field
                      tabIndex={'5'}
                      as='input'
                      type='radio'
                      id='transferTypeSelect2'
                      name='hasFxRefNo'
                      value='N'
                      onChange={(text) => {
                        handleChange(text)
                        setSelectedModeOfTransfer(text.target.value)
                      }}
                      className='custom-control-input'
                    />
                    <label className='custom-control-label' htmlFor='transferTypeSelect2'>
                      {t(BENEFICIARY_TRANSFER_KEYS.BENEFICIARY_TRANSFER.NO)}
                    </label>
                  </div>

                  {selectedModeOfTransfer === 'Y' && (
                    <>
                      <NeoInput
                        tabIndex='6'
                        text={`${t(BENEFICIARY_TRANSFER_KEYS.BENEFICIARY_TRANSFER.FX_REF_NO)} *`}
                        name='fxRefNo'
                        onChange={handleChange}
                      />
                      <InputError text={errors.fxRefNo} touched={touched.fxRefNo} />
                    </>
                  )}
                </div>
              )}

              <div className='form-group'>
                <NeoInput
                  tabIndex='7'
                  showAsterisk={internationalTransferConfig['isSenderInfoRequired']}
                  text={t(BENEFICIARY_TRANSFER_KEYS.BENEFICIARY_TRANSFER.SENDER_TO_RECEIVER)}
                  name='senderToReceiverInfo'
                  onChange={handleChange}
                />

                <InputError
                  text={errors.senderToReceiverInfo}
                  touched={touched.senderToReceiverInfo}
                />
              </div>
              {config.SCHEDULED_TRANSFERS && (
                <>
                  <div className='mt-3 form-group'>
                    <NeoInput
                      tabIndex='8'
                      showAsterisk={internationalTransferConfig['isSchedulePaymentRequired']}
                      text={t(DEPOSITS_KEYS.TERM_DEPOSITS_KEYS.SCHEDULE_TRANSFER)}
                      mode='select'
                      name='isScheduled'
                      onChange={(e) => {
                        handleChange(e)
                      }}
                      list={['Yes', 'No']}
                      keyValue={null}
                    />
                    <InputError text={errors.isScheduled} touched={touched.isScheduled} />
                  </div>

                  {values.isScheduled === 'Yes' && (
                    <div className='form-group mt-3'>
                      <NeoInput
                        tabIndex='9'
                        showAsterisk={internationalTransferConfig['isScheduleDateRequired']}
                        name='scheduledDate'
                        text={t(DEPOSITS_KEYS.TERM_DEPOSITS_KEYS.SCHEDULE_DATE)}
                        icon='calendar_today'
                        mode='single'
                        type='date'
                        onChange={handleChange}
                        min={moment(new Date()).format('YYYY-MM-DD')}
                      />
                      <InputError text={errors.scheduledDate} touched={touched.scheduledDate} />
                    </div>
                  )}
                </>
              )}

              <div className='mt-3 form-group'>
                <NeoInput
                  tabIndex='10'
                  showAsterisk={internationalTransferConfig['isRemarksRequired']}
                  text={t(DEPOSITS_KEYS.TERM_DEPOSITS_KEYS.REMARKS)}
                  mode='select'
                  name='remarks'
                  onChange={(e) => {
                    handleChange(e)
                  }}
                  list={remarksList}
                  keyValue={null}
                />
                <InputError text={errors.remarks} touched={touched.remarks} />
              </div>

              {values.remarks === 'Custom' && (
                <div className='row'>
                  <div className='form-group col-12'>
                    <NeoInput
                      tabIndex='11'
                      showAsterisk={internationalTransferConfig['isCustomRemarksRequired']}
                      text={t(DEPOSITS_KEYS.TERM_DEPOSITS_KEYS.CUSTOM_REMARK)}
                      onChange={handleChange}
                      name='customRemarks'
                      maxLength={config.REMARKS_MAX}
                    />
                    <InputError text={errors.customRemarks} touched={touched.customRemarks} />
                  </div>
                </div>
              )}
              {config.CHARGE_BORNE_BY && (
                <div className='mt-3 form-group'>
                  <NeoInput
                    tabIndex='12'
                    showAsterisk={internationalTransferConfig['isChargeBorneRequired']}
                    text={t(DEPOSITS_KEYS.TERM_DEPOSITS_KEYS.CHARGES_BORNE_BY)}
                    mode='select'
                    name='chargesBorneBy'
                    onChange={(e) => {
                      handleChange(e)
                    }}
                    list={['BEN', 'OUR', 'SHA']}
                    keyValue={null}
                  />
                  <InputError text={errors.chargesBorneBy} touched={touched.chargesBorneBy} />
                </div>
              )}
              <div className='mt-3'>
                {isSubmitting ? (
                  renderLoading()
                ) : (
                  <NeoButton
                    tabIndex='13'
                    type='submit'
                    mode={'newDesign'}
                    disabled={isSubmitting}
                    text={t(BENEFICIARY_TRANSFER_KEYS.TRANSFER_DETAILS_KEYS.SUBMIT)}
                  />
                )}
              </div>
              <div className='back-cancel-btn-container'>
                <button
                  className='back-cancel-btn btn btn-sm new-design-warning-text-color'
                  tabIndex={'14'}
                  onClick={() => history.goBack()}>
                  {' '}
                  {t(SIDENAV_KEYS.TOUCH_ID_KEYS.CANCEL)}
                </button>
              </div>
            </Form>
          )}
        </Formik>
      </>
    )
  }

  function renderConfirm() {
    return (
      <>
        <AccountDisplay currentAccountDetail={currentAccountDetail} />
        <p style={{ fontSize: 10, fontWeight: 600, paddingLeft: 30 }}>To</p>
        <BeneficiaryDisplay beneDetails={beneDetails} />
        <div className='d-flex flex-column confirmation'>
          <div>
            <h6 className='label'>
              {t(BENEFICIARY_TRANSFER_KEYS.TRANSFER_DETAILS_KEYS.TRANSFER_TYPE)}
            </h6>
            <h6 className='value'>{formValues?.transferType}</h6>
          </div>
          <div>
            <h6 className='label'>
              {t(BENEFICIARY_TRANSFER_KEYS.TRANSFER_CONFIRM_KEYS.TRANSFER_AMOUNT1)}
            </h6>
            <h6 className='value'>{formValues?.transferAmount}</h6>
          </div>

          <div>
            <h6 className='label'>{t(BENEFICIARY_TRANSFER_KEYS.TRANSFER_CONFIRM_KEYS.currency)}</h6>
            <h6 className='value'>{formValues.txnCurrency}</h6>
          </div>
          {config.FX_DEAL_REF_NO && (
            <>
              <div>
                <h6 className='label'>
                  {t(BENEFICIARY_TRANSFER_KEYS.BENEFICIARY_TRANSFER.HAS_FX_DEAL)}
                </h6>
                <h6 className='value'>{formValues.hasFxRefNo === 'N' ? 'No' : 'Yes'}</h6>
              </div>

              {formValues.hasFxRefNo === 'Y' && (
                <div>
                  <h6 className='label'>
                    {t(BENEFICIARY_TRANSFER_KEYS.BENEFICIARY_TRANSFER.FX_REF_NO)}
                  </h6>
                  <h6 className='value'>{formValues.fxRefNo}</h6>
                </div>
              )}
            </>
          )}

          <div>
            <h6 className='label'>
              {t(BENEFICIARY_TRANSFER_KEYS.BENEFICIARY_TRANSFER.SENDER_TO_RECEIVER)}
            </h6>
            <h6 className='value'>{formValues.senderToReceiverInfo}</h6>
          </div>
          {config.SCHEDULED_TRANSFERS && (
            <>
              <div>
                <h6 className='label'>{t(DEPOSITS_KEYS.TERM_DEPOSITS_KEYS.SCHEDULE_TRANSFER)}</h6>
                <h6 className='value'>{formValues?.isScheduled}</h6>
              </div>
              {formValues.isScheduled === 'Yes' && (
                <div>
                  <h6 className='label'>{t(DEPOSITS_KEYS.TERM_DEPOSITS_KEYS.SCHEDULE_DATE1)}</h6>
                  <h6 className='value'>{moment(formValues.scheduledDate).format('DD-MM-YYYY')}</h6>
                </div>
              )}
            </>
          )}
          <div>
            <h6 className='label'>{t(BENEFICIARY_TRANSFER_KEYS.TRANSFER_CONFIRM_KEYS.CHARGES)}</h6>
            <h6 className='value'>
              <NumberFormat
                value={verifyDetails?.charges || 0}
                displayType={'text'}
                thousandSeparator={true}
                prefix={''}
                fixedDecimalScale={true}
                decimalScale={2}
                allowEmptyFormatting
              />
            </h6>
          </div>
          <div>
            <h6 className='label'>
              {t(REQUESTS_KEYS.CHEQUE_KEYS.STOP_CHEQUE_PAYMENT_KEYS.REMARKS1)}
            </h6>
            <h6 className='value'>
              {formValues.remarks === 'Custom' ? formValues.customRemarks : formValues.remarks}
            </h6>
          </div>
          {config.CHARGE_BORNE_BY && (
            <div>
              <h6 className='label'>{t(DEPOSITS_KEYS.TERM_DEPOSITS_KEYS.CHARGES_BORNE_BY)}</h6>
              <h6 className='value'>{formValues?.chargesBorneBy}</h6>
            </div>
          )}

          <div>
            <TermsAndCondition module='BENEFICIARYTRANSFER' />
          </div>

          <div className='mt-3'>
            {loading ? (
              renderLoading()
            ) : (
              <NeoButton
                mode='newDesign'
                type='button'
                className='btn btn-neo'
                onClick={() =>
                  verifyDetails.repeat ? showConfirmModal() : otpEnabled ? setStage(3) : onConfirm()
                }
                text={t(BENEFICIARY_TRANSFER_KEYS.TRANSFER_CONFIRM_KEYS.CONFIRM)}
              />
            )}
          </div>
          <div className='back-cancel-style' onClick={() => setStage(1)}>
            {' '}
            {t(SIDENAV_KEYS.TOUCH_ID_KEYS.BACK)}
          </div>
        </div>
      </>
    )
  }

  return (
    <LayoutWithAccountCard breadCumKey='TRANSFER_INTERNATIONAL'>
      <div className='new-design-form-style'>
        <div className='heading-style'>
          {t(BENEFICIARY_TRANSFER_KEYS.BENEFICIARY_TRANSFER.INTERNATIONAL_TRANSFER_TITLE)}
        </div>

        <div>{renderSwitch()}</div>
      </div>
    </LayoutWithAccountCard>
  )
}
